let controller1 = new ScrollMagic.Controller();

let scene2 = new ScrollMagic.Scene({
    offset: -150,
    triggerElement: '.box2',
    triggerHook: "onenter",
    duration:0,
})
scene2.on("progress", function (event) {
    var index=event.progress.toFixed(3) * 100;
    $('.box2_title').addClass('showup')
    if(index<2){
        $('.box2_title').removeClass('showup')
    }
})

let scene3 = new ScrollMagic.Scene({
    offset: -150,
    triggerElement: '.box3',
    triggerHook: "onenter",
    duration:0,
})
scene3.on("progress", function (event) {
    var index=event.progress.toFixed(3) * 100;
    $('.box3_title').addClass('showup')
    if(index<2){
        $('.box3_title').removeClass('showup')
    }
})

let scene4 = new ScrollMagic.Scene({
    offset: 250,
    triggerElement: '.box4',
    triggerHook: "onenter",
    duration:0,
})
scene4.on("progress", function (event) {
    var index=event.progress.toFixed(3) * 100;
    $('.box4_title').addClass('showup')
    if(index<2){
        $('.box4_title').removeClass('showup')
    }
})

let scene5 = new ScrollMagic.Scene({
    offset: -60,
    triggerElement: '.box5',
    triggerHook: "0",
    duration:800,
})
scene5.setPin('.box5')
scene5.on("progress", function (event) {
    var index=event.progress.toFixed(3) * 100;
    if(index>5){
        if(window.innerWidth>750){
            $('.box5_title').css({transform:'translateY(2rem)',opacity:'0'})
        }
        if(index<80){
            $('.box5_img').css({transform:`translate(-50%,${mapValue(index,5,80,90,0)}%)`})
        }else{
            $('.box5_img').css({transform:`translate(-50%,0)`})
        }
        if(index>85){
            $('.box5_icon').css({transform:'translate(-50%,0)',opacity:'1'})
        }else{
            $('.box5_icon').css({transform:'translate(-50%,2rem)',opacity:'0'})
        }
    }else{
        $('.box5_title').css({transform:'translateY(0)',opacity:'1'})
        $('.box5_img').css({transform:`translate(-50%,90%)`})
    }
})

let scene6 = new ScrollMagic.Scene({
    offset: 0,
    triggerElement: '.box6',
    triggerHook: "onenter",
    duration:0,
})
scene6.on("progress", function (event) {
    var index=event.progress.toFixed(3) * 100;
    $('.box6_img').css({transform:'translateX(0)'})
    if(index<2){
        if(window.innerWidth>750){
            $('.box6_img').css({transform:'translateX(-80%)'})
        }else{
            $('.box6_img').css({transform:'translateX(-25rem)'})
        }
    }
})

let scene6_1 = new ScrollMagic.Scene({
    offset: -150,
    triggerElement: '.box6',
    triggerHook: "onenter",
    duration:0,
})
scene6_1.on("progress", function (event) {
    var index=event.progress.toFixed(3) * 100;
    $('.box6_title').addClass('showup')
    if(index<2){
        $('.box6_title').removeClass('showup')
    }
})

let scene7 = new ScrollMagic.Scene({
    offset: -50,
    triggerElement: '.box7',
    triggerHook: "onenter",
    duration:0,
})
scene7.on("progress", function (event) {
    var index=event.progress.toFixed(3) * 100;
    $('.box7_content').addClass('showup2')
    if(index<2){
        $('.box7_content').removeClass('showup2')
    }
})

let scene8 = new ScrollMagic.Scene({
    offset: -200,
    triggerElement: '.box8',
    triggerHook: "onenter",
    duration:0,
})
scene8.on("progress", function (event) {
    var index=event.progress.toFixed(3) * 100;
    $('.box8_title').addClass('showup')
    if(index<2){
        $('.box8_title').removeClass('showup')
    }
})

let scene9 = new ScrollMagic.Scene({
    offset: -150,
    triggerElement: '.box9',
    triggerHook: "onenter",
    duration:0,
})
scene9.on("progress", function (event) {
    var index=event.progress.toFixed(3) * 100;
    $('.box9_title').addClass('showup')
    if(index<2){
        $('.box9_title').removeClass('showup')
    }
})

let scene10 = new ScrollMagic.Scene({
    offset: 0,
    triggerElement: '.box10',
    triggerHook: "onenter",
    duration:0,
})
scene10.on("progress", function (event) {
    var index=event.progress.toFixed(3) * 100;
    $('.box10_title').addClass('showup2')
    if(index<2){
        $('.box10_title').removeClass('showup2')
    }
})

controller1.addScene([scene2,scene3,scene4,scene5,scene6,scene6_1,scene7,scene8,scene9,scene10]); 


//box3
if(window.innerWidth>750){
    var box3Swiper = new Swiper('.box3Swiper', {
        slidesPerView: 7,
        centeredSlides: true,
        loop: true,
        slideToClickedSlide: true,
        navigation: {
            nextEl: '.box3Swiper-button-next',
            prevEl: '.box3Swiper-button-prev',
        },
        on:{
            slideChangeTransitionEnd:function(){
                var index = this.realIndex+1
                $('.box3_top img').hide()
                $(`.box3_top img:nth-child(${index})`).show()
                $('.box3_name div').hide()
                $(`.box3_name div:nth-child(${index})`).show()
                $('.box3_right img').hide()
                $(`.box3_right img:nth-child(${index})`).show()
            },
        },
    })
    var box8Swiper = new Swiper('.box8Swiper', {
        slidesPerView: 5,
        centeredSlides: true,
        loop: true
    })
    box8Swiper.activeIndex = 2;
    box8Swiper.update()
}else{
    var box8Swiper = new Swiper('.box8Swiper', {
        slidesPerView: 3,
        centeredSlides: true,
        loop: true
    })
    box8Swiper.activeIndex = 5;
    box8Swiper.update()
    var box3Swiper = new Swiper('.box3Swiper', {
        slidesPerView: 7,
        centeredSlides: true,
        slideToClickedSlide: true,
        navigation: {
            nextEl: '.box3Swiper-button-next',
            prevEl: '.box3Swiper-button-prev',
        },
        on:{
            slideChangeTransitionEnd:function(){
                Mbox3Swiper.slideTo(this.activeIndex+1 , 300, false)
            },
        },
    })
    var Mbox3Swiper = new Swiper('.Mbox3Swiper', {
        loop: true,
        effect: 'fade',
        on:{
            slideChangeTransitionEnd:function(){
                box3Swiper.slideTo(this.realIndex , 300, false)
            },
        },
    })
    box3Swiper.activeIndex = 3
    Mbox3Swiper.activeIndex = 4
    Mbox3Swiper.update()
    box3Swiper.update()
}

//box8
$('.box8_btn div').click(function(){
    var index = $(this).index()+1
    $('.box8_btn div').removeClass('box8_btnActive')
    $(this).addClass('box8_btnActive')
    $('.box8_icon img').hide()
    $(`.box8_icon img:nth-child(${index})`).show()
})


$('.pnr_buy').click(function(){ 
    window.open('https://store.oxva.com/products/oxva-xlim-classic-edition'); 
})

$('.pnr_spec').click(function(){
    $('.Mpn_popup').css({height:'0'})
    buyFlag = true
    $('.classic_section1').hide()
    $('.classic_section2').show()
    window.scrollTo(0,0)
    $('.nav_flag .pnr_text:nth-child(2)').addClass('color_red')
    $('.nav_flag .pnr_text:nth-child(1)').removeClass('color_red')
})

$('.pnr_over2').click(function(){
    $('.Mpn_popup').css({height:'0'})
    buyFlag = true
    $('.classic_section2').hide()
    $('.classic_section1').show()
    window.scrollTo(0,0)
    $('.nav_flag .pnr_text:nth-child(1)').addClass('color_red')
    $('.nav_flag .pnr_text:nth-child(2)').removeClass('color_red')
})

$('.boxSpecs_btn').click(function(){
    $('.classic_section1').hide()
    $('.classic_section2').show()
    window.scrollTo(0,0)
    $('.nav_flag .pnr_text:nth-child(2)').addClass('color_red')
    $('.nav_flag .pnr_text:nth-child(1)').removeClass('color_red')
})

//box2
$('.box2_nav1').click(function(){
    var element = document.querySelector(".box4");
    element.scrollIntoView({block: "end"});
})
$('.box2_nav2').click(function(){
    var element = document.querySelector(".box6");
    element.scrollIntoView({block: "end"});
})
$('.box2_nav3').click(function(){
    var element = document.querySelector(".box5");
    element.scrollIntoView({block: "end"});
})
$('.box2_nav4').click(function(){
    var element = document.querySelector(".box8");
    element.scrollIntoView({block: "end"});
})
$('.box2_nav5').click(function(){
    var element = document.querySelector(".box6");
    element.scrollIntoView({block: "end"});
})